import React from 'react';
import TransformSection from './common/transform-section';
import MatchFilterSection from './shared/match-filter-section';
import type { ObjectInspectorProps } from './types';

/**
 * Rendered when a multi-selection spans different object kinds. Only the
 * cross-kind common fields apply: shared transform (no X/Y in bulk) and match
 * filtering. Kind-specific fields are unavailable until the selection is
 * homogeneous.
 */
const MixedInspector: React.FC<ObjectInspectorProps> = ({ objects, editor }) => (
  <>
    <TransformSection objects={objects} editor={editor} />
    <MatchFilterSection objects={objects} editor={editor} />
  </>
);

export default MixedInspector;
